import React, { useEffect, useState } from "react";
import FontIcon from "react-md/lib/FontIcons";
import "../styles/expandableTableAssignedPlans.css";
import Autocomplete from "@material-ui/lab/Autocomplete";
import EventService from "../../../../../service/event/EventService";
import moment from "moment";
import NoRecordsIcon from "../../../../../assets/icons/no-records.png";
import { Button, SelectField } from "react-md";
import filterApplied from "../../../../../assets/icons/filter-applied-icon.svg";
import funnelIcon from "../../../../../assets/icons/funnel.svg";
import goIcon from "../../../../../assets/icons/right_arrow_go_btn.svg";
import {
  TextField,
  MenuItem,
  Menu,
  IconButton,
  Radio,
  InputAdornment,
} from "@material-ui/core";

const ExpandableTableAssignedServiceProviders = (props) => {
  const [expandedRowId, setExpandedRowId] = useState(null); // state to track expanded row
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuFor, setMenuFor] = useState({});
  const [tableData, setTableData] = useState(
    props?.data?.assignedServiceProviders
  );
  const [filterObj, setFilterObj] = useState({});
  const [openFilter, setOpenFilter] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);

  const [loading, setLoading] = useState(false);
  const [serviceProviderIdFilterText, setServiceProviderIdFilterText] =
    useState("");

  useEffect(() => {
    console.log("props recvd in expandabel table: ", props);
  }, []);

  useEffect(() => {
    setTableData(props?.data?.assignedServiceProviders);
    console.log("props recvd in expandabel table: ", props);
  }, [props]);

  useEffect(() => {
    if (
      props?.fetchAssignedServiceProvidersByFilter &&
      props?.setAssignedServiceProviderPageNums &&
      props?.data?.serviceMode
    ) {
      props.fetchAssignedServiceProvidersByFilter(
        props?.data?.planId,
        props?.data?.serviceId,
        props?.data?.serviceMode,
        1,
        filterObj
      );
      props.setAssignedServiceProviderPageNums((prevPageNums) => ({
        ...prevPageNums,
        [props.data.serviceMode]: 1,
      }));
    }
    console.log("props recvd in expandabel table: ", props);
  }, [filterObj]);

  const STATUS_MAP = {
    Active: "active",
    Inactive: "inactive",
  };

  const handleRowClick = (id) => {
    setExpandedRowId(expandedRowId === id ? null : id); // toggle expansion
  };
  const handleMoreClick = (event, serviceProviderData) => {
    props.setView(5, {
      accountId: props?.data?.accountId,
      planId: props?.data?.planId,
      serviceId: serviceProviderData?.serviceId,
      serviceProviderId: serviceProviderData?.serviceProviderId,
      serviceMode: props?.data?.serviceMode,
    });
  };

  const handleEditServiceProviders = (ele, opt) => {
    console.log("ni ,  In expanadable tile  -> ", ele);
    if (opt == 1) {
      props.setView(6, {
        mode: "view",
        service: props?.data?.service,
        serviceProvider: ele,
      });
    } else if (opt == 2) {
      props.setView(6, {
        mode: "update",
        service: props?.data?.service,
        serviceProvider: ele,
      });
    }
  };

  return (
    <div className="table-container-assigned-plans">
      <table className="expandable-table-astp">
        <thead>
          <tr>
            <th>
              Service provider ID
              <img
                src={
                  (filterObj?.serviceProviderIds ?? []).length > 0
                    ? filterApplied
                    : funnelIcon
                }
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(4);
                }}
              />
              {openFilter === 4 && (
                <div
                  className="filter-div-assigned-plans-table"
                  style={{ flexDirection: "row" }}
                >
                  <TextField
                    id="appointment-dialog-client-code-filter-service-providerId"
                    className="appointment-dialog-client-code-filter-class"
                    placeholder="Service provider ID"
                    value={serviceProviderIdFilterText}
                    onChange={(e) => {
                      let inputValue = e.target.value.replace(/[^0-9,]/g, ""); // Allow only numbers and commas

                      setServiceProviderIdFilterText(inputValue);
                    }}
                    inputProps={{
                      maxLength: 20,
                    }}
                    InputProps={{
                      endAdornment: (serviceProviderIdFilterText ||
                        (filterObj?.serviceProviderIds ?? []).length > 0) && (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => {
                              setServiceProviderIdFilterText("");
                              let removedFilterObj = { ...filterObj };
                              delete removedFilterObj.serviceProviderIds;
                              setFilterObj({
                                ...removedFilterObj,
                                // pageNum: 1,
                              });
                              // setPageNum(1);
                            }}
                            edge="end"
                            size="small"
                          >
                            <FontIcon>close</FontIcon>
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <div
                    style={{ display: "flex", cursor: "pointer" }}
                    onClick={() => {
                      if (serviceProviderIdFilterText.trim()) {
                        const serviceProviderIds = serviceProviderIdFilterText
                          .split(",")
                          .map((id) => id.trim())
                          .filter((id) => id !== "" && !isNaN(id))
                          .map(Number);

                        setFilterObj({
                          ...filterObj,
                          // pageNum: 1,
                          serviceProviderIds,
                        });
                        // setPageNum(1);
                      }
                    }}
                  >
                    <img
                      src={goIcon}
                      alt="Go"
                      style={{
                        width: "20px",
                        height: "20px",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                </div>
              )}
            </th>
            <th>
              Service provider
              <img
                src={
                  (filterObj?.serviceProviderNames ?? []).length > 0
                    ? filterApplied
                    : funnelIcon
                }
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(7);
                }}
              />
              {openFilter === 7 && (
                <div className="filter-div-assigned-plans-table">
                  <Autocomplete
                    style={{
                      width: "200px",
                      maxHeight: "200px",
                      overflowY: "scroll",
                      overflowX: "hidden",
                    }}
                    multiple
                    id="multiple-limit-service-provider-name"
                    options={(
                      (
                        props?.data?.assignedServiceProvidersForFilters ?? []
                      ).filter((ele) =>
                        (ele?.serviceModes ?? []).some(
                          (el) =>
                            (el?.mode ?? "---") ===
                            (props?.data?.serviceMode ?? "-")
                        )
                      ) ?? []
                    )
                      .map((element) => element?.serviceProviderName ?? "")
                      .filter(
                        (elle, index, self) =>
                          elle &&
                          index ===
                            self.findIndex(
                              (t) => t.toLowerCase() === elle.toLowerCase()
                            )
                      )} // filtering out empty && removing duplicates
                    getOptionLabel={(option) => {
                      let res = option ?? "";
                      return res;
                    }}
                    value={filterObj?.serviceProviderNames ?? []}
                    onChange={(e, v) => {
                      if (v) {
                        // setFilterServiceProviderNameOptions(v);
                        setFilterObj({
                          ...filterObj,
                          // pageNum: 1,
                          serviceProviderNames: v.map((elem) => elem ?? ""),
                        });
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        onChange={(e, v) => {
                          // handleFetchServiceProviderNameOpt(e.target.value);
                        }}
                        {...params}
                        placeholder=""
                        className="autocomplete-text-field-class"
                      />
                    )}
                  />
                </div>
              )}
            </th>
            <th>
              City
              <img
                src={
                  (filterObj?.serviceProviderCities ?? []).length > 0
                    ? filterApplied
                    : funnelIcon
                }
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(5);
                }}
              />
              {openFilter === 5 && (
                <div className="filter-div-assigned-plans-table">
                  <Autocomplete
                    style={{
                      width: "200px",
                      maxHeight: "200px",
                      overflowY: "scroll",
                      overflowX: "hidden",
                    }}
                    multiple
                    id="multiple-limit-service-provider-name"
                    options={(
                      (
                        props?.data?.assignedServiceProvidersForFilters ?? []
                      ).filter((ele) =>
                        (ele?.serviceModes ?? []).some(
                          (el) =>
                            (el?.mode ?? "---") ===
                            (props?.data?.serviceMode ?? "-")
                        )
                      ) ?? []
                    )
                      .map((element) => element?.serviceProviderCity ?? "")
                      .filter(
                        (elle, index, self) =>
                          elle &&
                          index ===
                            self.findIndex(
                              (t) => t.toLowerCase() === elle.toLowerCase()
                            )
                      )} // filtering out empty && removing duplicates
                    getOptionLabel={(option) => {
                      let res = option ?? "";
                      return res;
                    }}
                    value={filterObj?.serviceProviderCities ?? []}
                    onChange={(e, v) => {
                      if (v) {
                        // setFilterServiceProviderNameOptions(v);
                        setFilterObj({
                          ...filterObj,
                          // pageNum: 1,
                          serviceProviderCities: v.map((elem) => elem ?? ""),
                        });
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        onChange={(e, v) => {
                          // handleFetchServiceProviderNameOpt(e.target.value);
                        }}
                        {...params}
                        placeholder=""
                        className="autocomplete-text-field-class"
                      />
                    )}
                  />
                </div>
              )}
            </th>
            <th>Whether availability customised</th>
            <th>
              Status on plan
              {/* <img
                className="filter-icon-assigned-plans"
                src={filterObj?.status ? filterApplied : funnelIcon}
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(1);
                }}
              />
              {openFilter === 1 && (
                <div className="filter-div-assigned-plans-table">
                  <div className="can-be-booked-for-filter">
                    {Object.entries(STATUS_MAP).map(([key, val]) => (
                      <div>
                        <Radio
                          label={key}
                          checked={filterObj?.status == val}
                          onClick={() => {
                            setOpenBackdrop(false);
                            setOpenFilter(-1);
                            setFilterObj((prev) => ({ ...prev, status: val }));
                          }}
                        />
                        <label className="label-radio-btn">{key}</label>
                      </div>
                    ))}
                    <Button
                      className="clear-navigo-booked-for"
                      onClick={() => {
                        setFilterObj((prev) => ({ ...prev, status: null }));
                      }}
                    >
                      Clear
                    </Button>
                  </div>
                </div>
              )} */}
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody className="animated-box">
          {Boolean(tableData?.length == null || tableData?.length <= 0) && (
            <tr>
              <td colSpan={5}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 40,
                  }}
                >
                  <div
                    style={{ textAlign: "center", fontFamily: "Montserrat" }}
                  >
                    No records to show
                  </div>
                  <div style={{ height: "16px" }}></div>
                  <img src={NoRecordsIcon} width={50} height={62} />
                </div>
              </td>
            </tr>
          )}

          {tableData && tableData.length > 0 && (
            <tr>
              <td />
              <td />
              <td />
              <td />
              <td
                colSpan={5}
                align="right"
                style={{ display: "flex", flexDirection: "row" }}
              >
                <Button
                  onClick={() => {
                    props.goToPrevPage(props?.data?.serviceMode, filterObj);
                  }}
                  disabled={props?.pageNum <= 1 || loading}
                >
                  <FontIcon className="navigo-count-icon">arrow_left</FontIcon>
                </Button>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  Showing&nbsp;
                  <span
                    style={{
                      color: "#ef7c01",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    {(props?.pageNum - 1) * props?.pageSize + 1}&nbsp;
                  </span>
                  <span
                    style={{
                      color: "#ef7c01",
                    }}
                  >
                    -
                  </span>
                  <span
                    style={{
                      color: "#ef7c01",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    &nbsp;
                    {props?.totalCount > props?.pageNum * props?.pageSize
                      ? props?.pageNum * props?.pageSize
                      : props?.totalCount}
                  </span>
                  <span>&nbsp;&nbsp;of&nbsp;</span>
                  <span>{` ${props?.totalCount}`}</span>
                </div>
                <Button
                  onClick={() => {
                    props.goToNextPage(props?.data?.serviceMode, filterObj);
                  }}
                  disabled={
                    loading ||
                    props?.pageNum * props?.pageSize > props?.totalCount ||
                    (props?.totalCount > props?.pageNum * props?.pageSize
                      ? props?.pageNum * props?.pageSize
                      : props?.totalCount) == props?.totalCount
                  }
                >
                  <FontIcon>arrow_right</FontIcon>
                </Button>
              </td>
            </tr>
          )}

          {tableData?.map((row, index) => (
            <React.Fragment key={index}>
              <tr
                // onClick={() => handleRowClick(row?.serviceProviderId)}
                className={`${index > 0 ? "table-row-border" : ""}`}
              >
                <td>{row?.serviceProviderId}</td>
                <td>{row?.serviceProviderName}</td>
                <td>{row?.serviceProviderCity}</td>
                <td>{row?.serviceModes?.[0]?.isCustomized ? "Yes" : "No"}</td>
                <td>
                  {
                    <div
                      className={`${
                        row?.isActive
                          ? "navigo-appoint-non-select-status-active"
                          : "navigo-appoint-non-select-status-inactive"
                      } `}
                    >
                      <span>{row?.isActive ? "Active" : "Inactive"}</span>
                    </div>
                  }
                </td>
                <td>
                  <FontIcon
                    style={{ cursor: "pointer", color: "#F97F0F" }}
                    onClick={(e) => handleMoreClick(e, row)}
                  >
                    edit
                  </FontIcon>
                </td>
              </tr>
            </React.Fragment>
          ))}
        </tbody>
      </table>
      {openBackdrop && (
        <div
          style={{
            position: "fixed",
            left: 0,
            top: 0,
            width: "100vw",
            height: "100vh",
          }}
          onClick={() => {
            setOpenFilter(-1);
            setOpenBackdrop(false);
          }}
        ></div>
      )}
    </div>
  );
};

export default ExpandableTableAssignedServiceProviders;
